import React from 'react';
import { Container, RemovePoText } from './AddPoButton.styled';
import { useTranslation } from 'react-i18next';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
export default function AddPoButton({
    showRemovePOText = true,
    removeAllPo,
    onOpenModal,
    enablePObutton,
}) {
    const { t } = useTranslation();
    return (
        <Container>
            <Button
            id={'reportUsage-reportPayment-record-addPoButton'}
                show={true}
                // primary={enablePObutton ? true : false}
                variant={enablePObutton ? ButtonStyles?.primary : ButtonStyles?.disabled}
                height={'32px'}
                width={'92px'}
                clicked={onOpenModal}
                margin={'10px 2px 10px 0px'}
                // fontSize={'15px'}
                disabled={!enablePObutton}
            >
                {t('reportUsage.addPo')}
            </Button>
            {showRemovePOText ? (
                <RemovePoText
                    id="reportUsage-record-removePoText"
                    onClick={removeAllPo}
                >
                    {t('reportUsage.record.reportPayment.ItemList.ReportPaymentItemListMobile.removePo')}
                </RemovePoText>
            ) : null}
        </Container>
    );
}
